export default {
  namespace: true,
  state: {
    modalName: 'AppDialog',
    actionType: '',
    dialogItem: {
      header: '',
      message: '',
      width: '',
      icon: '',
      iconSize: '',
      acceptLabel: '',
      rejectLabel: '',
      dialogType: ''
    }
  },
  mutations: {
    CLOSE_DIALOG (state) {
      state.actionType = '';
      state.modalName = '';

      Object.keys(state.dialogItem).forEach((item, index) => {
        state.dialogItem[item] = '';
      });
    },
    OPEN_DIALOG (state, { dialogSetting, type, modalName }) {
      state.actionType = type;
      state.modalName = modalName;

      Object.keys(dialogSetting).forEach((item, num) => {
        state.dialogItem[item] = dialogSetting[item];
      });
    }
  },
  action: {}
};
